/**
 * Service for assigned employees list operations
 */

import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import { buildQueryString } from '@/api/shared/queryBuilder';
import type { ApiResponse } from '@/api/shared/types';
import { mapAssignedEmployeesListResultToModel } from '../mappers';
import type {
  AssignedEmployeesListFilters,
  AssignedEmployeesListResult,
  LC_AssignedEmployeesListOut,
} from '../types';


export class AssignedEmployeesListService {
  async list(
    filters?: AssignedEmployeesListFilters,
    signal?: AbortSignal,
  ): Promise<ApiResponse<AssignedEmployeesListResult>> {
    const params: Record<string, string | number | undefined | null> = { ...filters };
    if (params['status'] === 'all') {
      delete params['status'];
    }
    if (!params['orderBy']) {
      delete params['orderBy'];
      delete params['orderDirection'];
    }

    const queryString = buildQueryString(params);
    const endpoint = `${API_CONFIG.ENDPOINTS.SECURITY_GROUPING.ASSIGNED_EMPLOYEES}${queryString}`;

    const response = await apiClient.get<LC_AssignedEmployeesListOut>(endpoint, { signal });

    if (response.success && response.data) {
      return {
        ...response,
        data: mapAssignedEmployeesListResultToModel(response.data),
      };
    }

    return { ...response, data: null };
  }
}

export const assignedEmployeesListService = new AssignedEmployeesListService();
